// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__OEg_8","active":"NavigationItem_active__3okvF"};